<!-- 百度 单元 表格 -->
<template>
	<div class="table-box" >
		<!-- 表头 -->
		<div class="table-th" ref="table_th" :style="{'width': table_scroll_width + 'px'}">
			<div class="table-th-cell-sticky" style="display: flex;align-items: center;">
				<div class="table-th-cell"
				:style="{'width':30 + 'px'}">
					<a-checkbox :indeterminate="indeterminate" :checked="checkAll" @change="onCheckAllChange"></a-checkbox>
				</div>
				<div class="table-th-cell"
				:style="{'width':rableTitle[0].width + 'px'}" style="cursor: default;" 
				@click="sortClick(0)">
					单元名称
				</div>
				
				<div class="table-th-cell" style="cursor: default;"
				:style="{'width':rableTitle[1].width + 'px'}" 
				@click="sortClick(2)">
					操作
				</div>
				
			</div>
			
			<div  v-for="(item,index) in rableTitle" :key="index" >
	
				<div v-if="(item.type !== 'adgroupFeedName' && item.type !== 'cz') && item.show_control" class="table-th-cell" 
				:style="{'width':item.width + 'px','cursor':item.sort_control?'pointer':'default','justify-content': item.text_right?'flex-end':''}"
				@click="sortClick(index)">
					{{item.title}}
					<div v-if="item.sort_control" style="display: flex;flex-direction: column;width: 12px;margin-left: 5px;">
						<a-icon type="caret-up" :style="{'color': item.sort_status === 2?'#1890ff':'#999'}" style="font-size: 12px;margin-bottom: -4px;" />
						<a-icon type="caret-down" :style="{'color': item.sort_status === 1?'#1890ff':'#999'}" style="font-size: 12px;" />
					</div>
				</div>
			</div>
			<!-- 占位，隔出一个空白区域 -->
			<div id="" style="padding:15px;"></div>
		</div>
		
		<!-- 总计 -->
		<div v-if="tableShowData.length > 0" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
			<div class="table-td-cell-sticky" style="display: flex;align-items: center;">
				<!-- 选择 -->
				<div class="table-td-cell" :style="{'width':30 + 'px'}">
					
				</div>
				<div class="table-td-cell"
				:style="{'width':rableTitle[0].width + 'px'}">
					总计
				</div>
				<div  class="table-td-cell"
				:style="{'width':rableTitle[1].width + 'px'}">
					
				</div>
			</div>
			<!-- 单元状态 -->
			<div class="table-td-cell" :style="{'width': rableTitle[2].width + 'px'}" :class="{'text-right': rableTitle[2].text_right}">
				
			</div>
			<!-- 出价(元) -->
			<div class="table-td-cell" :style="{'width': rableTitle[3].width + 'px'}" :class="{'text-right': rableTitle[3].text_right}">
				
			</div>
			<!-- 消耗 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[4].width + 'px'}">
				{{tableSumData.cost || 0}}
			</div>
			<!-- 展示数 -->
			<div v-show="!jj_checked" class="table-td-cell text-right" :style="{'width': rableTitle[5].width + 'px'}">
				{{tableSumData.impression || 0}}
			</div>
			<!-- ecpm -->
			<div v-show="!jj_checked" class="table-td-cell text-right" :style="{'width': rableTitle[6].width + 'px'}" >
				{{tableSumData.cpm || 0}}
			</div>
			<!-- 点击数 -->
			<div  v-show="!jj_checked" class="table-td-cell text-right" :style="{'width': rableTitle[7].width + 'px'}">
				{{tableSumData.click || 0}}
			</div>
			<!-- 平均点击单价 -->
			<div v-show="!jj_checked" class="table-td-cell text-right" :style="{'width': rableTitle[8].width + 'px'}">
				{{tableSumData.cpc || 0}}
			</div>
			<!-- 点击率 -->
			<div v-show="!jj_checked" class="table-td-cell text-right" :style="{'width': rableTitle[9].width + 'px'}">
				{{tableSumData.ctr || 0}}
			</div>
			
			<!-- 微信调起按钮点击量 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[10].width + 'px'}">
				{{tableSumData.weiXinAppButtonConversions || 0}}
			</div>
			<!-- 微信调起按钮点击成本 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[11].width + 'px'}">
				{{tableSumData.weiXinAppButtonConversionsCost || 0}}
			</div>
			<!-- 微信加粉成功量 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[12].width + 'px'}">
				{{tableSumData.weixinFollowSuccessConversions || 0}}
			</div>
			<!-- 微信加粉成功成本 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[13].width + 'px'}">
				{{tableSumData.weixinFollowSuccessConversionsCost || 0}}
			</div>
			<!-- 微信复制按钮点击量 -->
			<div v-show="!jj_checked" class="table-td-cell text-right" :style="{'width': rableTitle[14].width + 'px'}">
				{{tableSumData.weiXinCopyConversions || 0}}
			</div>
			<!-- 微信复制按钮点击成本 -->
			<div v-show="!jj_checked" class="table-td-cell text-right" :style="{'width': rableTitle[15].width + 'px'}">
				{{tableSumData.weiXinCopyConversionsCost || 0}}
			</div>
			
			<!-- 转化数 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[16].width + 'px'}">
				{{tableSumData.ocpcTargetTrans || 0}}
			</div>
			<!-- 平均转化成本 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[17].width + 'px'}">
				{{tableSumData.ocpcTargetTransCPC || 0}}
			</div>
			<!-- 转化率 -->
			<div v-show="!jj_checked" class="table-td-cell text-right" :style="{'width': rableTitle[18].width + 'px'}">
				{{tableSumData.ocpcTargetTransRatio || 0}}
			</div>
			<!-- 总充值金额 -->
			<div v-show="!jj_checked" class="table-td-cell text-right" :style="{'width': rableTitle[19].width + 'px'}">
				{{tableSumData.eff_total_pay_money || 0}}
			</div>
			<!-- 分成金额 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[20].width + 'px'}">
				{{tableSumData.eff_total_left_money || 0}}
			</div>
			<!-- 首充分成金额 -->
			<div v-show="!jj_checked" class="table-td-cell text-right" :style="{'width': rableTitle[21].width + 'px'}">
				{{tableSumData.eff_total_left_money_fisrt || 0}}
			</div>
			<!-- ROI -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[22].width + 'px'}">
				{{tableSumData.eff_roi*100 | tableToFixed}}%
			</div>
			<!-- 首充ROI -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[23].width + 'px'}">
				{{tableSumData.eff_roi_first*100 | tableToFixed}}%
			</div>
			
			<!-- 当天订单笔数 -->
			<div v-show="!jj_checked" class="table-td-cell text-right" :style="{'width': rableTitle[24].width + 'px'}">
				{{tableSumData.eff_total_order_cnt || 0}}
			</div>
			<!-- 当天充值用户数 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[25].width + 'px'}">
				{{tableSumData.eff_total_pay_user_cnt || 0}}
			</div>
			<!-- 当天充值用户成本 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[26].width + 'px'}">
				{{tableSumData.eff_total_pay_user_cost | tableToFixed}}
			</div>
			<!-- ARPU -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[27].width + 'px'}">
				{{tableSumData.arpu | tableToFixed}}
			</div>
			<!-- 回传用户数 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[28].width + 'px'}">
				{{tableSumData.eff_report_pay_user_cnt || 0}}
			</div>
			<!-- 回传用户成本 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[29].width + 'px'}">
				{{tableSumData.eff_report_pay_user_cost | tableToFixed}}
			</div>
			
			
		</div>
		
		<!-- 表格内容 -->
		<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
			<div class="table-td-cell-sticky" style="display: flex;align-items: center;">
				<!-- 选择 -->
				<div class="table-td-cell" :style="{'width':30 + 'px'}">
					<a-checkbox :checked="item.checked" @change="onChangeCheckbox($event,index)"></a-checkbox>
				</div>
				<div  @click='operation(1,item)' class="table-td-cell"
				:style="{'width':rableTitle[0].width + 'px'}" style="color: #2F88FF;cursor: pointer;">
					{{item.adgroupFeedName}}
				</div>

				<div  class="table-td-cell" style="display: flex;align-items: center;justify-content: space-between;"
				:style="{'width':rableTitle[1].width + 'px'}">
					<a-switch size="small" :checked="item.status_checked" default-checked @change="onStatusCheckbox($event,item)"  checked-children="启用" un-checked-children="暂停"/>
					
					<!-- <a-popover :visible="item.popover_clicked" @visibleChange="handleClickChange($event,item)" trigger="click" placement="bottom">
						<template slot="content">
						  <div>
							  <div @click="zhOperation(5,item)" class='cz-button-calss'>复制</div>
							  <div @click="zhOperation(1,item)" class='cz-button-calss'>编辑</div>
							  <div @click="zhOperation(2,item)" class='cz-button-calss'>新建回传比例任务</div>
							  <div @click="zhOperation(3,item)" class='cz-button-calss'>新建出价任务</div>
							  <div @click="zhOperation(7,item)" class='cz-button-calss'>管理出价任务</div>
						  </div>
						</template>
						
						<a-icon style="font-size: 18px;font-weight: bold;cursor: pointer;margin-left: 7px;" type="more" />
					</a-popover> -->
					<div @click="zhOperation(8,item)" class='cz-cell'>小时数据</div>
					<div @click="zhOperation(9,item)" class='cz-cell'>天数据</div>
				</div>
			</div>
			<!-- 单元状态 -->
			<div class="table-td-cell"  :style="{'width': rableTitle[2].width + 'px'}" :class="{'text-right': rableTitle[2].text_right}">
				{{item.status | dyStatus}}
			</div>
			<!-- 出价(元) -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[3].width + 'px'}" >
				{{item.bid || 0}}
				<div v-if="item.bidtype == 3" style="font-size:12px;color: #ccc;">OCPC/oCPM</div>
				<div v-else style="font-size:12px;color: #ccc;">其他</div>
			</div>
			<!-- 消耗 -->
			<div @mouseenter='TDmouseenter(index)' class="table-td-cell text-right" :style="{'width': rableTitle[4].width + 'px'}" >
				{{item.cost || 0}}
			</div>
			<!-- 展示数 -->
			<div v-show="!jj_checked" class="table-td-cell text-right" :style="{'width': rableTitle[5].width + 'px'}">
				{{item.impression || 0}}
			</div>
			<!-- ecpm -->
			<div v-show="!jj_checked" class="table-td-cell text-right" :style="{'width': rableTitle[6].width + 'px'}">
				{{item.cpm || 0}}
			</div>
			<!-- 点击数 -->
			<div  v-show="!jj_checked" class="table-td-cell text-right" :style="{'width': rableTitle[7].width + 'px'}">
				{{item.click || 0}}
			</div>
			<!-- 平均点击单价 -->
			<div v-show="!jj_checked" class="table-td-cell text-right" :style="{'width': rableTitle[8].width + 'px'}">
				{{item.cpc || 0}}
			</div>
			<!-- 点击率 -->
			<div v-show="!jj_checked" class="table-td-cell text-right" :style="{'width': rableTitle[9].width + 'px'}">
				{{item.ctr || 0}}
			</div>
			<!-- 微信调起按钮点击量 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[10].width + 'px'}">
				{{item.weiXinAppButtonConversions || 0}}
			</div>
			<!-- 微信调起按钮点击成本 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[11].width + 'px'}">
				{{item.weiXinAppButtonConversionsCost || 0}}
			</div>
			<!-- 微信加粉成功量 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[12].width + 'px'}">
				{{item.weixinFollowSuccessConversions || 0}}
			</div>
			<!-- 微信加粉成功成本 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[13].width + 'px'}">
				{{item.weixinFollowSuccessConversionsCost || 0}}
			</div>
			<!-- 微信复制按钮点击量 -->
			<div v-show="!jj_checked" class="table-td-cell text-right" :style="{'width': rableTitle[14].width + 'px'}">
				{{item.weiXinCopyConversions || 0}}
			</div>
			<!-- 微信复制按钮点击成本 -->
			<div v-show="!jj_checked" class="table-td-cell text-right" :style="{'width': rableTitle[15].width + 'px'}">
				{{item.weiXinCopyConversionsCost || 0}}
			</div>
			<!-- 转化数 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[16].width + 'px'}">
				{{item.ocpcTargetTrans || 0}}
			</div>
			<!-- 平均转化成本 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[17].width + 'px'}">
				{{item.ocpcTargetTransCPC || 0}}
			</div>
			<!-- 转化率 -->
			<div v-show="!jj_checked" class="table-td-cell text-right" :style="{'width': rableTitle[18].width + 'px'}">
				{{item.ocpcTargetTransRatio || 0}}
			</div>
			<!-- 总充值金额 -->
			<div v-show="!jj_checked" class="table-td-cell text-right" :style="{'width': rableTitle[19].width + 'px'}">
				{{item.eff_total_pay_money || 0}}
			</div>
			<!-- 分成金额 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[20].width + 'px'}">
				{{item.eff_total_left_money || 0}}
			</div>
			<!-- 首充分成金额 -->
			<div v-show="!jj_checked" class="table-td-cell text-right" :style="{'width': rableTitle[21].width + 'px'}">
				{{item.eff_total_left_money_fisrt || 0}}
			</div>
			<!-- ROI -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[22].width + 'px'}">
				{{item.eff_roi*100 | tableToFixed}}%
			</div>
			<!-- 首充ROI -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[23].width + 'px'}">
				{{item.eff_roi_first*100 | tableToFixed}}%
			</div>
			
			<!-- 当天订单笔数 -->
			<div v-show="!jj_checked" class="table-td-cell text-right" :style="{'width': rableTitle[24].width + 'px'}">
				{{item.eff_total_order_cnt || 0}}
			</div>
			<!-- 当天充值用户数 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[25].width + 'px'}">
				{{item.eff_total_pay_user_cnt || 0}}
			</div>
			<!-- 当天充值用户成本 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[26].width + 'px'}">
				{{item.eff_total_pay_user_cost | tableToFixed}}
			</div>
			<!-- ARPU -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[27].width + 'px'}">
				{{item.arpu | tableToFixed}}
			</div>
			<!-- 回传用户数 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[28].width + 'px'}">
				{{item.eff_report_pay_user_cnt || 0}}
			</div>
			<!-- 回传用户成本 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[29].width + 'px'}">
				{{item.eff_report_pay_user_cost | tableToFixed}}
			</div>
			
			<!-- 回传比例 -->
			<div @click="setPlanHc(item)" class="table-td-cell" :style="{'width': rableTitle[30].width + 'px'}" style="cursor: pointer;color: rgb(98, 168, 234);">
				<div v-if="item.report_config" style="display: flex;flex-wrap: wrap;align-items: center;">
					<div v-if="item.report_config.status == 1" style="margin-right: 7px;flex-shrink: 0;">
						<a-tag color="green">已启用</a-tag>
					</div>
					<div v-else style="flex-shrink: 0;margin-right: 7px;">
						<a-tag>未启用</a-tag>
					</div>
					
					<template v-if="item.report_config.report_per_type == 1">
						<div>
							固定序列
						</div>
						<div style="width: 100%;height: 5px;"></div>
						<div>回传比例：{{item.report_config.report_per}}</div>
						<div style="margin-left: 10px;">回传最低金额：{{item.report_config.report_money_limit || 0}}</div>
					</template>
					<template v-else-if="item.report_config.report_per_type == 2">
						<div>自定义序列</div>
					</template>
				</div>
				<div v-else>
					未设置
				</div>
				
			</div>
			<!-- 百度创建时间 -->
			<div class="table-td-cell" :style="{'width': rableTitle[31].width + 'px'}">
				{{item.addtime}}
			</div>
				
			<!-- 单元ID -->
			<div class="table-td-cell" :style="{'width': rableTitle[32].width + 'px'}">
				<div v-if="item.adgroupFeedId">{{item.adgroupFeedId}}</div>
				
			</div>
			<!-- 计划名称 -->
			<div class="table-td-cell" :style="{'width': rableTitle[33].width + 'px'}">
				{{item.campaignFeedName}}
			</div>
			<!-- 账户名称 -->
			<div class="table-td-cell" :style="{'width': rableTitle[34].width + 'px'}">
				{{item.account_name}}
			</div>
			<!-- 投手 -->
			<div class="table-td-cell" :style="{'width': rableTitle[35].width + 'px'}">
				<div v-if="item.admin_list.length > 0" style="display: flex;align-items: center;flex-wrap: wrap;">
					<div v-for="(item,index) in item.admin_list" :key="index" style="margin: 0 10px 5px 0;">
						{{item.admin_name}}
					</div>
				</div>
			</div>
		</div>
		
		
		<div v-show="tableShowData.length === 0" style="text-align: center;margin: 80px auto 50px;">
			<a-icon style="font-size: 70px;color: #999;" type="file-search" />
			
			<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
		</div>
		
		
		<div style="position: fixed;right: 0;bottom:0;z-index: 6;background-color: #fff;height: 92vh;width: 30px;"></div>
		<div style="position: fixed;left: 0;bottom:0;z-index: 6;background-color: #fff;height: 92vh;width: 30px;"></div>
		
		
	</div>
</template>

<script>
export default {
	name: 'BDdyTable',
	props: ['rableTitle','tableShowData','tableSumData','table_scroll_width','jj_checked','indeterminate','checkAll'],
	data(){
		return {
			
			select_sort_index: "", // 筛选的
			
			popover_clicked: false,
		}
	},
	methods: {
		sortClick(index){ // 点击表头给内容进行排序
			let that = this
			let th_status // 0是默认，1是箭头向下，2是箭头向上
			console.log(that.rableTitle[index].type)
			if(that.rableTitle[index].sort_control){ // 是否有排序功能
				if(index !== this.select_sort_index){
					this.select_sort_index = index
					that.rableTitle.forEach(res=>{
						res.sort_status = 0
					})
					that.rableTitle[index].sort_status = 1
					th_status = 1
				}
				else { // 点击的是同一个表头
					if(that.rableTitle[index].sort_status === 0){
						that.rableTitle[index].sort_status = 1 // 箭头向下
						th_status = 1
					}
					else if(that.rableTitle[index].sort_status === 1){
						that.rableTitle[index].sort_status = 2 // 箭头向上
						th_status = 2
					}
					else if(that.rableTitle[index].sort_status === 2){
						that.rableTitle[index].sort_status = 0
						th_status = 0
					}
				}
				
				
				
				this.$emit('table-th-click', index, th_status, that.rableTitle[index].type)
			}
		},
		// editTable(index){
		// 	this.$emit('edit-td-click', index)
		// },
		TDmouseenter(index){
			// console.log(index);
		},
		// 操作
		operation(e,item){
			console.log(item)
			if(e == 1){ // 点击账户名称
				// 这里使用params方式传参，而不用query是因为，params的参数不会拼在url后面，这样子刷新页面后，传过来的参数就可以自动清空
				this.$router.replace({name: 'BDcy_',params: {jump_id: item.adgroupFeedId}})
			}
			else if(e == 2){ // 点击负责人
				this.$emit('click-Fzr', item)
			}
			
		},
		handleClickChange(e,item){
			console.log(e)
			item.popover_clicked = e
		},
		// 表格内的操作项
		zhOperation(e,item){
			console.log(item);
			if(e == 1){ // 同步账户信息
				item.popover_clicked = false
				this.$emit('sync-zhxx-click', item)
			}
			else if(e == 8){ // 小时数据
				this.$emit('td-handle', 8, item)
			}
			else if(e == 9){ // 天数据
				this.$emit('td-handle', 9, item)
			}
		},
		
		// 全选
		onCheckAllChange(e){
			this.$emit('click-All-Checkbox', e)
		},
		// 单选
		onChangeCheckbox(checkedList,index){
			this.$emit('click-Checkbox', checkedList,index)
		},
		
		// 操作项的开关
		onStatusCheckbox(e,item){ // 启用或暂停
			// console.log(e,item);
			this.$message.warning('仅展示状态，无操作');
			// this.$emit('status-Checkbox', e, item)
		},
		
		// 设置计划回传比例
		setPlanHc(item){
			// console.log(item);
			this.$emit('set-Plan-Hcbl', item)
		}
	},
	filters: {
		dyStatus(value){
			// console.log("过滤器",value)
			let vvv 
			if(value === 0){
				vvv = "有效"
			}
			else if(value === 1){
				vvv = "暂停推广"
			}
			else if(value === 2){
				vvv = "推广计划暂停推广"
			}
			return vvv
		},
		tableToFixed(value){ // 保留小数点后两位，四舍五入
			// console.log("过滤器",value)
			if(value){
				let v = Number(value)
				return v.toFixed(2)
			}
			else {
				return 0
			}
			
		}
	}
}
</script>

<style scoped>
.cz-button-calss {
	font-size: 13px;
	padding:10px;
	cursor: pointer;
}
.cz-button-calss:hover {
	background-color: #f4f7fa;
}

/* 表格样式-非公共/基础样式 */
.table-th-cell {
	height: 59px;
}
.table-th-cell:hover {
	background-color: #eee;
}
.table-th-cell:hover .table-th-cell-sticky{
	background-color: #eee;
}

.table-td-cell {
	font-size: 12px;
}

.cz-cell {
	color: #62a8ea;
	cursor: pointer;
	/* margin-right: 7px; */
	/* margin-top: 5px; */
}
.cz-cell:hover{
	color: rgb(47, 136, 255);
}
</style>